import { useState, useEffect } from "react";

export default function Extensions(props) {
  return (
    <div className="insider-tips--container">
      <div className="insider-tips--title">Insider’s Tips:</div>
      <div className="insider-tips--body">{props.extension}</div>
    </div>
  );
}
